<div class="relative inline-block">
  <div class="inline-block" #triggerWrapper>
    <ng-content select="[ss-popover-trigger]"></ng-content>
  </div>

  @if (isVisible()) {
    <div
      #popoverContent
      [class]="popoverClasses()"
      [style.top]="appendToBody() ? popoverPosition().top : null"
      [style.left]="appendToBody() ? popoverPosition().left : null"
      [@popoverAnimation]="position()"
    >
      <ng-content select="[ss-popover-content]"></ng-content>
    </div>
  }
</div>
